import React from 'react'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ATDropdownActionButtonProps } from './FormComponentProps'
import Authorize from '../auth/Authorize'
import { getWidgetMapping } from '../../../utils/authUtil/AuthUtil'
import { PERMISSIONS, WIDGET_TYPE } from '../auth/AuthorizeConstant'

const ATDropdownActionButton: React.FC<ATDropdownActionButtonProps> = ({
  variant,
  id,
  size,
  title,
  actionArray,
}) => {
  const { t } = useTranslation(['translation'])
  return (
    <DropdownButton variant={variant} id={id} size={size} title={t(title)}>
      {actionArray.map((action: any) => {
        return (
          <div key={action?.name}>
            <Authorize
              widgetId={getWidgetMapping(action?.permission)}
              widgetType={WIDGET_TYPE.DROPDOWN_ITEM}
            >
              <Dropdown.Item
                onClick={action?.functionName}
                className="table-dropdown-item"
              >
                {t(action?.name)}
              </Dropdown.Item>
            </Authorize>
          </div>
        )
      })}
    </DropdownButton>
  )
}

export default ATDropdownActionButton
